/**
 * El botón «Paquete» (PDF de presupuestos + preoperatorio) con el aviso del
 * ácido hialurónico ANTES de abrirlo (revisión del 21/10/2026;
 * components/AvisoHialuronico.jsx).
 *
 * Es el mismo PdfLangButton de siempre. Cada vez que se abre el menú del
 * idioma se pide el aviso del paciente con las hojas que imprimiría el
 * paquete (las mismas que `bundle-pdf`): si lo lleva, sale encima de los
 * idiomas, con DÓNDE, y si NINGUNA hoja lleva la hialuronidasa se dice claro.
 * No frena: se elige idioma y se abre igual. Se pide al abrir y no al pintar
 * la lista, para no lanzar una consulta por cada presupuesto de la pantalla.
 */
import React, { useState } from 'react';
import PdfLangButton from './PdfLangButton';
import AvisoHialuronico, { useAvisoHialuronico } from './AvisoHialuronico';

export default function PaquetePdfButton({ budget, children, ...props }) {
  const [abierto, setAbierto] = useState(false);
  // Cuántas veces se ha abierto: cada apertura lo vuelve a pedir, por si entre
  // medias se ha añadido la línea. El de la vez anterior no se enseña al
  // reabrir: el hook solo devuelve la respuesta de la petición de ahora.
  const [vez, setVez] = useState(0);
  const aviso = useAvisoHialuronico({
    patientId: budget?.patient_id, budgetId: budget?.id, activo: vez > 0, recarga: vez,
  });
  const hojas = Array.isArray(aviso?.hojas_del_paquete) ? aviso.hojas_del_paquete : null;
  return (
    <PdfLangButton
      {...props}
      onMenu={(v) => { setAbierto(v); if (v) setVez((n) => n + 1); }}
      menuClassName={abierto && aviso ? 'w-80' : 'w-44'}
      antes={abierto && aviso ? (
        <AvisoHialuronico aviso={aviso} modo="paquete" hojas={hojas} compacto testId="paquete-pdf-aviso-hialuronico" />
      ) : null}
    >
      {children}
    </PdfLangButton>
  );
}
